module.exports = __webpack_public_path__ + "img/blood-logo.15faa69f.webp";